import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Popup } from 'next-common-lib';
import { useFormik } from 'formik';
import i18n from 'i18n';
import TextFieldFormik from 'components/Common/InputBox';
import TblList from 'components/Common/Template/TblList';
import PopConfirmButton from 'components/Common/Buttons/PopConfirmButton';
import TblCell from 'components/Common/Template/TblCell';
import * as wizardActions from 'redux/ducks/common/wizardDuck';
import * as jobTitleActions from 'redux/ducks/JobTitle/JobTitleDucks';
import jobTitleSchema from './JobTitleSchema';

export const PopupJobTitle = () => {
  const dispatch = useDispatch();
  const isPopup = useSelector(state => state.wizard.isPopup);
  const isSuccess = useSelector(state => state.jobTitle.isSuccess);

  const formik = useFormik({
    initialValues: { compStrcCd: '', compStrcCdNm: '' },
    validationSchema: jobTitleSchema,
    onSubmit: values => {
      const payload = {
        compStrcCd: values.compStrcCd.toUpperCase(),
        compStrcCdNm: values.compStrcCdNm,
      };
      dispatch(jobTitleActions.createJobTitle(payload));
    },
  });
  const handleOnClose = () => {
    formik.handleReset();
    dispatch(wizardActions.closePopup());
  };

  useEffect(() => {
    if (isSuccess) {
      handleOnClose();
    }
  }, [isSuccess]);

  return (
    <>
      {isPopup && (
        <Popup
          id="jobtitlePopup"
          isShow={isPopup}
          isDimed={isPopup}
          dimedClassName="transparent"
          zIndex={2500}
          isDimedOverlap
          size="sm w-popup"
          useScroll={false}
          componentType="normalPopup"
          closeFunction={() => {
            handleOnClose();
          }}
          headerComponent={[
            <h1 className="popup-title" key={1}>
              {i18n.t('MB_T_ADD_JOBRANK')}
            </h1>,
          ]}
          contentsComponent={[
            <div className="article-body">
              <TblList>
                <TblCell isHeader>{i18n.t('MB_T_GRADE_JOBRANKCODE')}</TblCell>
                <TblCell>
                  <TextFieldFormik
                    id="compStrcCd"
                    formik={formik}
                    placeholderLabel={i18n.t('MB_M_GRADE_JS_JOBRANKCODE')}
                    maxLength={30}
                    useExpLabel={formik.errors.compStrcCd !== undefined}
                    autoFocus
                  />
                </TblCell>
              </TblList>
              <TblList>
                <TblCell isHeader>{i18n.t('MB_T_COMMON_JOBRANK')}</TblCell>
                <TblCell>
                  <TextFieldFormik
                    id="compStrcCdNm"
                    formik={formik}
                    maxLength={30}
                    useExpLabel={formik.errors.compStrcCdNm !== undefined}
                    placeholderLabel={i18n.t('MB_M_GRADE_JS_JOBRANKNAME')}
                  />
                </TblCell>
              </TblList>
            </div>,
          ]}
          bottomComponent={[<PopConfirmButton confirmAction={formik.submitForm} cancelAction={handleOnClose} />]}
        />
      )}
    </>
  );
};
PopupJobTitle.propTypes = {};
PopupJobTitle.defaultProps = {};
export default PopupJobTitle;
